import { createApiAction, createAction } from '@saucelabs/sl-util-redux';

import * as generalAPI from './../general/api';
import * as types from './types';

export const cleanupTestError = createAction(types.CLEANUP_TEST_ERROR);

export const getAggregatedTestErrors = createApiAction(
  types.GET_AGGREGATED_TEST_ERRORS,
  (params) => generalAPI.getAggregatedTestErrors(params),
  { meta: { skipErrorPage: true } },
);

export const getTestsByError = createApiAction(
  types.GET_TESTS_BY_ERROR,
  (params) => generalAPI.getTestsByError(params),
  { meta: { skipErrorPage: true } },
);
